import Vue from 'vue'
import Router from 'vue-router'
import login from '@/pages/login'
import register from '@/pages/register'
import forgetPwd from '@/pages/forget-pwd'
import cmpDetail from '@/pages/cmp-detail'
import search from '@/pages/search'
import userAgree from '@/pages/user-agree'

Vue.use(Router)


const router = new Router({
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve=>require(['@/pages/index'],resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/forget-pwd',
      name: 'forgetPwd',
      component: forgetPwd
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/user-agree',
      name: 'userAgree',
      component: userAgree
    },
    {
      path: '/in-park',
      name: 'in-park',
      component: resolve=>require(['@/pages/in-park'],resolve), //走进园区
      redirect:'/in-park/desc',
      children:[
        {
          path:'/in-park/desc', //园区简介
          name:'desc',
          component:resolve => require(['@/pages/in-park/desc'],resolve),
        },
        {
          path:'/in-park/law', //政策法规
          name:'law',
          component:resolve => require(['@/pages/in-park/law'],resolve),
        },
        {
          path:'/in-park/detail', //政策法规详情
          name:'detail',
          component:resolve => require(['@/pages/in-park/detail'],resolve),
        },
      ]
    },
    {
      path: '/new-enter-park',
      name: 'enter-park',
      component: resolve=>require(['@/pages/new-enter-park'],resolve), //企业入园
      redirect:'/enter-park/cmp',
      children:[
        {
          path:'/enter-park/policy', //扶持政策
          name:'policy',
          component:resolve => require(['@/pages/enter-park/policy'],resolve),
          redirect:'/enter-park/cmp',
        },
        {
          path:'/enter-park/enter-term', //入驻条件
          name:'enter-term',
          component:resolve => require(['@/pages/enter-park/enter-term'],resolve),
        },
        {
          path:'/enter-park/enter-apply', //入驻申请
          name:'enter-apply',
          component:resolve => require(['@/pages/enter-park/enter-apply'],resolve),
        },
        {
          path:'/enter-park/cmp', //园区企业
          name:'cmp',
          component:resolve => require(['@/pages/enter-park/cmp'],resolve),
        },
      ]
    },
    {
      path: '/base',
      name: 'base',
      component: resolve=>require(['@/pages/base'],resolve), //双创基地
      redirect:'/two-base/desc',
      children:[
        {
          path:'/two-base/desc', //简介
          name:'b-desc',
          component:resolve => require(['@/pages/two-base/desc'],resolve),
        },
        {
          path:'/two-base/policy', //扶持政策
          name:'b-policy',
          component:resolve => require(['@/pages/two-base/policy'],resolve),
        },
        {
          path:'/two-base/enter-term', //入驻条件
          name:'b-enter-term',
          component:resolve => require(['@/pages/two-base/enter-term'],resolve),
        },
        {
          path:'/two-base/enter-apply', //入驻申请
          name:'b-enter-apply',
          component:resolve => require(['@/pages/two-base/enter-apply'],resolve),
        },
        {
          path:'/two-base/hotline', //咨询热线
          name:'hotline',
          component:resolve => require(['@/pages/two-base/hotline'],resolve),
        },
      ]
    },
    {
      path: '/news-info',
      name: 'news-info',
      component: resolve=>require(['@/pages/news-info'],resolve), //新闻资讯
      redirect:'/news-info/news',
      children:[
        {
          path:'/news-info/news', //新闻资讯
          name:'news',
          component:resolve => require(['@/pages/news-info/news'],resolve),
        },
        {
          path:'/news-info/industry', //行业资讯
          name:'industry',
          component:resolve => require(['@/pages/news-info/industry'],resolve),
        },
        {
          path:'/news-info/detail', //新闻行业详情
          name:'detail',
          component:resolve => require(['@/pages/news-info/detail'],resolve),
        },
      ]
    },
    {
      path: '/park-build',
      name: 'park-build',
      component: resolve=>require(['@/pages/park-build'],resolve), //园区党建
      redirect:'/park-build/organ-survey',
      children:[
        {
          path:'/park-build/organ-survey', //组织概况
          name:'organ-survey',
          component:resolve => require(['@/pages/park-build/organ-survey'],resolve),
        },
        {
          path:'/park-build/elegant', //党建风采
          name:'elegant',
          component:resolve => require(['@/pages/park-build/elegant'],resolve),
        },
        {
          path:'/park-build/activity', //党建活动
          name:'activity',
          component:resolve => require(['@/pages/park-build/activity'],resolve),
        },
        {
          path:'/park-build/detail', //详情
          name:'detail',
          component:resolve => require(['@/pages/park-build/detail'],resolve),
        },
      ]
    },
    {
      path: '/park-serve',
      name: 'park-serve',
      component: resolve=>require(['@/pages/park-serve'],resolve), //园区服务
      redirect:'/park-serve/serve-book',
      children:[
        {
          path:'/park-serve/serve-book', //园区咨询
          name:'consult',
          component:resolve => require(['@/pages/park-serve/serve-book'],resolve),
        },
        {
          path:'/park-serve/consult', //园区咨询
          name:'consult',
          component:resolve => require(['@/pages/park-serve/consult'],resolve),
        },
        {
          path:'/park-serve/consult-detail', //园区咨询
          name:'consult-detail',
          component:resolve => require(['@/pages/park-serve/consult-detail'],resolve),
        },
        {
          path:'/park-serve/consult-ask', //园区咨询提问
          name:'consult-ask',
          component:resolve => require(['@/pages/park-serve/consult-ask'],resolve),
          meta:{
            requireAuth:true, // 添加该字段，表示进入这个路由是需要登录的
          },
        },
        {
          path:'/park-serve/forum', //园区贴吧
          name:'forum',
          component:resolve => require(['@/pages/park-serve/forum'],resolve),
        },
        {
          path:'/park-serve/forum-publish', //园区贴吧发布
          name:'forum-publish',
          component:resolve => require(['@/pages/park-serve/forum-publish'],resolve),
          meta:{
            requireAuth:true,
          },
        },
        {
          path:'/park-serve/forum-detail', //园区贴吧详情
          name:'forum-detail',
          component:resolve => require(['@/pages/park-serve/forum-detail'],resolve),
        },
        {
          path:'/park-serve/down', //下载专区
          name:'down',
          component:resolve => require(['@/pages/park-serve/down'],resolve),
        },
        {
          path:'/park-serve/data-report', //数据提报
          name:'data-report',
          component:resolve => require(['@/pages/park-serve/data-report'],resolve),
        },
      ]
    },
    {
      path: '/center-home',
      name: 'park-serve',
      component: resolve=>require(['@/pages/etprise-center/center-home'],resolve), //企业中心
      redirect:'/etprise-center/etprise-info',
      meta:{
        requireAuth:true,
      },
      children:[
        {
          path:'/etprise-center/info', //企业信息
          name:'info',
          component:resolve => require(['@/pages/etprise-center/info'],resolve),
        },
        {
          path:'/etprise-center/product', //企业产品
          name:'product',
          component:resolve => require(['@/pages/etprise-center/product'],resolve),
        },
        {
          path:'/etprise-center/honor', //企业荣誉
          name:'honor',
          component:resolve => require(['@/pages/etprise-center/honor'],resolve),
        },
        {
          path:'/etprise-center/business-need', //业务需求
          name:'business-need',
          component:resolve => require(['@/pages/etprise-center/business-need'],resolve),
        },
        {
          path:'/etprise-center/business-supply', //业务供给
          name:'business-supply',
          component:resolve => require(['@/pages/etprise-center/business-supply'],resolve),
        },
        {
          path:'/etprise-center/recruit', //企业招聘
          name:'recruit',
          component:resolve => require(['@/pages/etprise-center/recruit'],resolve),
        },
        {
          path:'/etprise-center/serve-book', //服务预约
          name:'serve-book',
          component:resolve => require(['@/pages/etprise-center/serve-book'],resolve),
        },
        {
          path:'/etprise-center/serve-book-detail', //服务预约详情
          name:'serve-book-detail',
          component:resolve => require(['@/pages/etprise-center/serve-book-detail'],resolve),
        },
        {
          path:'/news-center', //消息中心
          name:'news-center',
          component:resolve => require(['@/pages/news-center'],resolve),
        },
        {
          path:'/etprise-center/related-data', //企业相关数据
          name:'related-data',
          component:resolve => require(['@/pages/etprise-center/related-data'],resolve),
        },
        {
          path:'/change-pwd', //修改密码
          name:'change-pwd',
          component:resolve => require(['@/pages/change-pwd'],resolve),
        },
      ]
    },
    {
      path: '/person-center',
      name: 'person-center',
      component: resolve=>require(['@/pages/person-center/person-center'],resolve), //个人中心
      redirect:'/person-center/resume',
      meta:{
        requireAuth:true,
      },
      children:[
        {
          path:'/person-center/resume', //个人简历
          name:'consult',
          component:resolve => require(['@/pages/person-center/resume'],resolve),
        },
        {
          path:'/person/change-pwd', //修改密码
          name:'change-pwd',
          component:resolve => require(['@/pages/change-pwd'],resolve),
        },
        {
          path:'/person/news-center', //消息中心
          name:'news-center',
          component:resolve => require(['@/pages/news-center'],resolve),
        },
      ]
    },
    {
      path: '/company-detail',
      name: 'cmpDetail',
      component: cmpDetail
    },
    {
      path: '/canvass-business',
      name: 'canvass-business',
      component: resolve=>require(['@/pages/canvass-business'],resolve), //智慧招商
    },
    {
      path: '/trade/index',
      name: 'trade-index',
      component: resolve=>require(['@/pages/trade/index'],resolve), //交易首页
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/enter-recruit',
      name: 'enter-recruit',
      component: resolve=>require(['@/pages/trade/enter-recruit'],resolve), //交易企业招聘
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/enter-recruit-detail',
      name: 'enter-recruit-detail',
      component: resolve=>require(['@/pages/trade/enter-recruit-detail'],resolve), //交易企业招聘详情
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/enter-recruit-publish',
      name: 'enter-recruit-publish',
      component: resolve=>require(['@/pages/trade/enter-recruit-publish'],resolve), //交易企业招聘
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/product-service',
      name: 'product-service',
      component: resolve=>require(['@/pages/trade/product-service'],resolve), //交易产品服务
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/product-service-publish',
      name: 'product-service-publish',
      component: resolve=>require(['@/pages/trade/product-service-publish'],resolve), //交易产品服务发布
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/product-service-detail',
      name: 'product-service-detail',
      component: resolve=>require(['@/pages/trade/product-service-detail'],resolve), //交易产品服务详情
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/organ',
      name: 'organ',
      component: resolve=>require(['@/pages/trade/organ'],resolve), //交易服务机构
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/about-us',
      name: 'about-us',
      component: resolve=>require(['@/pages/trade/about-us'],resolve), //交易关于我们
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/supply-demand',
      name: 'supply-demand',
      component: resolve=>require(['@/pages/trade/supply-demand'],resolve), //交易供需对接
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/supply-demand-detail',
      name: 'supply-demand-detail',
      component: resolve=>require(['@/pages/trade/supply-demand-detail'],resolve), //交易供需对接详情
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/supply-demand-publish',
      name: 'supply-demand-publish',
      component: resolve=>require(['@/pages/trade/supply-demand-publish'],resolve), //交易供需对接发布
      meta:{
        type:'trade'
      }
    },
    {
      path: '/trade/center-home',
      name: 'trade-park-serve',
      component: resolve=>require(['@/pages/trade/center-home'],resolve), //企业中心
      redirect:'/trade/etprise-center/business-need',
      meta:{
        requireAuth:true,
        type:'trade'
      },
      children:[
        {
          path:'/trade/etprise-center/business-need', //业务需求
          name:'trade-business-need',
          component:resolve => require(['@/pages/etprise-center/business-need'],resolve),
          meta:{
            type:'trade'
          },
        },
        {
          path:'/trade/etprise-center/business-supply', //业务供给
          name:'business-supply',
          component:resolve => require(['@/pages/etprise-center/business-supply'],resolve),
          meta:{
            type:'trade'
          },
        },
        {
          path:'/trade/etprise-center/recruit', //企业招聘
          name:'recruit',
          component:resolve => require(['@/pages/etprise-center/recruit'],resolve),
          meta:{
            type:'trade'
          },
        },
        {
          path:'/trade/news-center', //消息中心
          name:'news-center',
          component:resolve => require(['@/pages/news-center'],resolve),
          meta:{
            type:'trade'
          },
        },
        {
          path:'/trade/change-pwd', //修改密码
          name:'change-pwd',
          component:resolve => require(['@/pages/change-pwd'],resolve),
          meta:{
            type:'trade'
          },
        },
      ]
    },
    {
      path: '/trade/person-center',
      name: 'trade-person-center',
      component: resolve=>require(['@/pages/trade/person-center'],resolve), //个人中心
      redirect:'/trade/person-center/resume',
      meta:{
        requireAuth:true,
        type:'trade'
      },
      children:[
        {
          path:'/trade/person-center/resume', //个人简历
          name:'consult',
          component:resolve => require(['@/pages/person-center/resume'],resolve),
          meta:{
            type:'trade'
          },
        },
        {
          path:'/trade/person/change-pwd', //修改密码
          name:'change-pwd',
          component:resolve => require(['@/pages/change-pwd'],resolve),
          meta:{
            type:'trade'
          },
        },
        {
          path:'/trade/person/news-center', //消息中心
          name:'news-center',
          component:resolve => require(['@/pages/news-center'],resolve),
          meta:{
            type:'trade'
          },
        },
      ]
    },
    {
      path: '/trade/search',    //交易平台的搜索页面
      name: 'trade-search',
      component: resolve=>require(['@/pages/trade/search'],resolve),
      meta:{
        type:'trade'
      }
    },
    {
      path: '/test',    //测试anime.js
      name: 'test',
      component: resolve=>require(['@/pages/test'],resolve), //测试页
    },
  ]
})
router.beforeEach((to, from, next)=>{
  let token = localStorage.getItem('token');
  if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
    if (token) { // 判断当前的token是否存在 ； 登录存入的token
      next();
    }else {
      next({
        path: '/login',
        query: {redirect: location.hostname} // 将要跳转路由的path作为参数，传递到登录页面
      })
    }
  }else if(to.name=='login'&&token){
    next('/')
  }else {
    next();
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js